/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {combineReducers, configureStore, getDefaultMiddleware} from '@reduxjs/toolkit'
import {firebaseReducer, getFirebase} from 'react-redux-firebase'
import {firestoreReducer, getFirestore} from 'redux-firestore'
import appSlice from './app-slice'
import userSlice from './user-slice'
import notificationSlice from './notification-slice'

const initialState = {}

const rootReducer = combineReducers({
  app: appSlice,
  user: userSlice,
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  notification: notificationSlice,
})

const configureAppStore = (preloadedState = initialState) => {
  return configureStore({
    middleware: [
      ...getDefaultMiddleware({
        thunk: {
          extraArgument: {getFirebase, getFirestore},
        },
        serializableCheck: false,
      }),
    ],
    reducer: rootReducer,
    preloadedState,
  })
}
export {configureAppStore as default}
